import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { apiRequest } from '../authConfig.js';
import { adminGetUsers } from '../api.js';
import styles from './NavBar.module.css';

export default function NavBar() {
  const { instance, accounts } = useMsal();
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false);
  const account = accounts[0];

  useEffect(() => {
    if (!account) {
      return;
    }

    // Check admin status by fetching users (only admins can call this endpoint)
    instance
      .acquireTokenSilent({ ...apiRequest, account })
      .then((resp) => adminGetUsers(resp.idToken))
      .then(() => setIsAdmin(true))
      .catch(() => setIsAdmin(false)); // 403 = not admin
  }, [account, instance]);

  function handleLogout() {
    instance.logoutRedirect({ postLogoutRedirectUri: window.location.origin });
  }

  return (
    <header className={styles.header}>
      <div className={styles.left}>
        <Link to="/" className={styles.logo}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="3" width="7" height="7" />
            <rect x="14" y="3" width="7" height="7" />
            <rect x="14" y="14" width="7" height="7" />
            <rect x="3" y="14" width="7" height="7" />
          </svg>
          Portal Power BI
        </Link>
      </div>

      <nav className={styles.nav}>
        <Link to="/" className={styles.navLink}>
          Relatórios
        </Link>
        {isAdmin && (
          <Link to="/admin" className={styles.navLink}>
            Administração
          </Link>
        )}
      </nav>

      <div className={styles.right}>
        {account && (
          <span className={styles.userName}>
            {account.name || account.username}
          </span>
        )}
        <button className={styles.logoutBtn} onClick={handleLogout}>
          Sair
        </button>
      </div>
    </header>
  );
}
